import * as React from 'react';
export const IcFanSpeedTurbo = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.07 8l5.2 3a1 1 0 001.36-.37A2.75 2.75 0 0011.94 9a4 4 0 00-2.27-3c-2.74-1.58-4.45-.31-5 .59a1 1 0 00-.1.76 1 1 0 00.5.65zm5.66 4.39a.998.998 0 00-.1-.76c-.51-.89-2.22-2.17-5-.59A4 4 0 003.4 14a2.75 2.75 0 00.31 1.67 1 1 0 001.36.37l5.2-3a1 1 0 00.46-.65zM11 13c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1zm9.29-4.63A1 1 0 0018.93 8l-5.2 3a1 1 0 00-.46.61 1 1 0 00.1.76 2.869 2.869 0 002.51 1.34 4.85 4.85 0 002.45-.71 4 4 0 002.27-3 2.75 2.75 0 00-.31-1.63zM18.93 16l-5.2-3a1 1 0 00-1.36.37 2.75 2.75 0 00-.31 1.63 4 4 0 002.27 3 4.85 4.85 0 002.45.75 2.87 2.87 0 002.51-1.34.998.998 0 00.1-.76 1 1 0 00-.46-.65zM13 11c1 0 3-.84 3-4s-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1z'
      fill='currentColor'
    />
  </svg>
);
